export default {"src":"/_next/static/media/img-login-illust.2707be93.svg","height":679,"width":610,"blurWidth":0,"blurHeight":0};